export enum EnumTipoCobrancaRevenda {
    ClienteFinal = 0,
    Revenda = 1,
    RevendaPagas = 2,
}